import React from 'react';
import PropTypes from 'prop-types';
import ReactCountryFlag from 'react-country-flag';
import './WebScraper.scss';

const FLAG_CODE_OVERRIDES: Record<string, string> = {
  EP: 'EU',
  UP: 'EU',
};

function normalizeFlagCode(code?: string): string {
  const cc = (code || '').slice(0, 2).toUpperCase();
  if (!cc) return '';
  return FLAG_CODE_OVERRIDES[cc] || cc;
}

export const CountryFlag = ({
  code,
  size = 16,
  title,
  className,
}: {
  code?: string;
  size?: number;
  title?: string;
  className?: string;
}) => {
  const cc = (code || '').slice(0, 2).toUpperCase();
  if (!cc) return null;

  const countryCode = normalizeFlagCode(code);

  return (
    <ReactCountryFlag
      svg
      countryCode={countryCode}
      aria-label={title || cc}
      className={className ? `ws-country-flag ${className}` : 'ws-country-flag'}
      style={{ width: Math.round((size * 4) / 3), height: size }}
    />
  );
};

CountryFlag.propTypes = {
  code: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  className: PropTypes.string,
};

/**
 * Non-ISO codes or organizational entities that Intl.DisplayNames can't resolve.
 */
export const COUNTRY_LABELS: Record<string, string> = {
  EP: 'Europe',
  UP: 'Unitary Patent',
  WIPO: 'WIPO',
  GB: 'Great Britain',
};

let regionNames: Intl.DisplayNames | null = null;
function getRegionNames(): Intl.DisplayNames | null {
  if (regionNames) return regionNames;
  try {
    regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
    return regionNames;
  } catch {
    return null;
  }
}

export const formatCountryLabel = (
  code: string,
  labels: Record<string, string> = COUNTRY_LABELS
) => {
  const cc = (code || '').toUpperCase();
  if (!cc) return '';
  if (labels[cc]) return labels[cc];
  const dn = getRegionNames();
  if (dn) {
    try {
      const name = dn.of(cc);
      if (name && name !== cc) return name;
    } catch {
      /* fall through */
    }
  }
  return cc;
};
